export default __webpack_public_path__ + "static/media/powell.file_.197fab0f.jpg";